<!-- Plus icon -->
@if (icon == 'plus_circle') {
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48566 0 0 4.48566 0 10C0 15.5143 4.48566 20 10 20C15.5143 20 20 15.5136 20 10C20 4.48645 15.5143 0 10 0ZM10 18.4508C5.34082 18.4508 1.54918 14.66 1.54918 10C1.54918 5.34004 5.34082 1.54918 10 1.54918C14.6592 1.54918 18.4508 5.34004 18.4508 10C18.4508 14.66 14.66 18.4508 10 18.4508Z"
      fill="#03C0FC"
    />
    <path
      d="M13.8726 9.15617H10.7742V6.05781C10.7742 5.63023 10.428 5.2832 9.99963 5.2832C9.57127 5.2832 9.22502 5.63023 9.22502 6.05781V9.15617H6.12666C5.6983 9.15617 5.35205 9.5032 5.35205 9.93078C5.35205 10.3584 5.6983 10.7054 6.12666 10.7054H9.22502V13.8038C9.22502 14.2313 9.57127 14.5784 9.99963 14.5784C10.428 14.5784 10.7742 14.2313 10.7742 13.8038V10.7054H13.8726C14.301 10.7054 14.6472 10.3584 14.6472 9.93078C14.6472 9.5032 14.301 9.15617 13.8726 9.15617Z"
      fill="#03C0FC"
    />
  </svg>
}
@if (icon == 'plus_circle_hover') {
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48566 0 0 4.48566 0 10C0 15.5143 4.48566 20 10 20C15.5143 20 20 15.5136 20 10C20 4.48645 15.5143 0 10 0ZM10 18.4508C5.34082 18.4508 1.54918 14.66 1.54918 10C1.54918 5.34004 5.34082 1.54918 10 1.54918C14.6592 1.54918 18.4508 5.34004 18.4508 10C18.4508 14.66 14.66 18.4508 10 18.4508Z"
      fill="#0a58ca"
    />
    <path
      d="M13.8726 9.15617H10.7742V6.05781C10.7742 5.63023 10.428 5.2832 9.99963 5.2832C9.57127 5.2832 9.22502 5.63023 9.22502 6.05781V9.15617H6.12666C5.6983 9.15617 5.35205 9.5032 5.35205 9.93078C5.35205 10.3584 5.6983 10.7054 6.12666 10.7054H9.22502V13.8038C9.22502 14.2313 9.57127 14.5784 9.99963 14.5784C10.428 14.5784 10.7742 14.2313 10.7742 13.8038V10.7054H13.8726C14.301 10.7054 14.6472 10.3584 14.6472 9.93078C14.6472 9.5032 14.301 9.15617 13.8726 9.15617Z"
      fill="#0a58ca"
    />
  </svg>
}

@if (icon == 'calender') {
  <svg
    class="me-2"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6562 1.5625H16.7188V0H15.1562V1.5625H4.84375V0H3.28125V1.5625H2.34375C1.05141 1.5625 0 2.61391 0 3.90625V17.6562C0 18.9486 1.05141 20 2.34375 20H17.6562C18.9486 20 20 18.9486 20 17.6562V3.90625C20 2.61391 18.9486 1.5625 17.6562 1.5625ZM18.4375 17.6562C18.4375 18.087 18.087 18.4375 17.6562 18.4375H2.34375C1.91297 18.4375 1.5625 18.087 1.5625 17.6562V7.34375H18.4375V17.6562ZM18.4375 5.78125H1.5625V3.90625C1.5625 3.47547 1.91297 3.125 2.34375 3.125H3.28125V4.6875H4.84375V3.125H15.1562V4.6875H16.7188V3.125H17.6562C18.087 3.125 18.4375 3.47547 18.4375 3.90625V5.78125Z"
      fill="#03C0FC"
    />
    <path
      d="M4.53125 8.98438H2.96875V10.5469H4.53125V8.98438Z"
      fill="#03C0FC"
    />
    <path
      d="M7.65625 8.98438H6.09375V10.5469H7.65625V8.98438Z"
      fill="#03C0FC"
    />
    <path
      d="M10.7812 8.98438H9.21875V10.5469H10.7812V8.98438Z"
      fill="#03C0FC"
    />
    <path
      d="M13.9062 8.98438H12.3438V10.5469H13.9062V8.98438Z"
      fill="#03C0FC"
    />
    <path
      d="M17.0312 8.98438H15.4688V10.5469H17.0312V8.98438Z"
      fill="#03C0FC"
    />
    <path
      d="M4.53125 12.1094H2.96875V13.6719H4.53125V12.1094Z"
      fill="#03C0FC"
    />
    <path
      d="M7.65625 12.1094H6.09375V13.6719H7.65625V12.1094Z"
      fill="#03C0FC"
    />
    <path
      d="M10.7812 12.1094H9.21875V13.6719H10.7812V12.1094Z"
      fill="#03C0FC"
    />
    <path
      d="M13.9062 12.1094H12.3438V13.6719H13.9062V12.1094Z"
      fill="#03C0FC"
    />
    <path
      d="M4.53125 15.2344H2.96875V16.7969H4.53125V15.2344Z"
      fill="#03C0FC"
    />
    <path
      d="M7.65625 15.2344H6.09375V16.7969H7.65625V15.2344Z"
      fill="#03C0FC"
    />
    <path
      d="M10.7812 15.2344H9.21875V16.7969H10.7812V15.2344Z"
      fill="#03C0FC"
    />
    <path
      d="M13.9062 15.2344H12.3438V16.7969H13.9062V15.2344Z"
      fill="#03C0FC"
    />
    <path
      d="M17.0312 12.1094H15.4688V13.6719H17.0312V12.1094Z"
      fill="#03C0FC"
    />
  </svg>
}

@if (icon == 'telephone') {
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2297_68333)">
      <path
        d="M4.0752 13.2947C6.04785 15.6527 8.42249 17.5093 11.1328 18.823C12.1647 19.3121 13.5447 19.8923 15.0822 19.9917C15.1776 19.9959 15.2687 20 15.3641 20C16.396 20 17.2248 19.6436 17.9003 18.9101C17.9045 18.9059 17.9127 18.8976 17.9169 18.8893C18.1573 18.5993 18.4308 18.3382 18.7167 18.0605C18.9115 17.874 19.1104 17.6792 19.3011 17.4803C20.1838 16.5603 20.1838 15.3916 19.2928 14.5006L16.8021 12.0099C16.3794 11.5707 15.8738 11.3386 15.3433 11.3386C14.8129 11.3386 14.3031 11.5707 13.868 12.0058L12.3844 13.4894C12.2476 13.4107 12.1067 13.3402 11.9741 13.2739C11.8083 13.191 11.655 13.1123 11.5182 13.0253C10.1672 12.1674 8.94051 11.0485 7.7677 9.61044C7.17508 8.86034 6.77723 8.23042 6.49957 7.58807C6.88913 7.23581 7.25382 6.86697 7.60608 6.50642C7.7304 6.37795 7.85887 6.24948 7.98734 6.12101C8.43492 5.67344 8.67528 5.15541 8.67528 4.62909C8.67528 4.10278 8.43906 3.58475 7.98734 3.13717L6.75237 1.9022C6.60732 1.75715 6.47056 1.61625 6.32966 1.4712C6.05614 1.18939 5.77019 0.899296 5.48838 0.63821C5.06153 0.219644 4.56008 0 4.02962 0C3.5033 0 2.9977 0.219644 2.55427 0.642354L1.00434 2.19229C0.440722 2.75591 0.121617 3.4397 0.0553097 4.23125C-0.0234305 5.22172 0.158915 6.27435 0.631356 7.54662C1.35659 9.51513 2.45067 11.3427 4.0752 13.2947ZM1.0665 4.31828C1.11623 3.76709 1.32758 3.30709 1.72543 2.90924L3.26708 1.36759C3.50744 1.13552 3.77267 1.01533 4.02962 1.01533C4.28241 1.01533 4.53935 1.13552 4.77557 1.37588C5.05324 1.63282 5.31432 1.9022 5.59613 2.18815C5.73703 2.3332 5.88208 2.47824 6.02713 2.62743L7.26211 3.86241C7.51905 4.11935 7.65166 4.38044 7.65166 4.63738C7.65166 4.89432 7.51905 5.15541 7.26211 5.41235C7.13364 5.54082 7.00516 5.67344 6.87669 5.80191C6.49128 6.19146 6.13073 6.5603 5.73289 6.91256C5.7246 6.92085 5.72046 6.92499 5.71217 6.93328C5.3682 7.27725 5.42207 7.60464 5.50496 7.85329C5.5091 7.86573 5.51325 7.87402 5.51739 7.88645C5.83649 8.65313 6.27993 9.38251 6.97201 10.2528C8.21528 11.7862 9.52485 12.9755 10.967 13.8914C11.1452 14.0075 11.3359 14.0986 11.5141 14.1898C11.6798 14.2727 11.8332 14.3514 11.9699 14.4385C11.9865 14.4467 11.9989 14.455 12.0155 14.4633C12.1523 14.5338 12.2849 14.5669 12.4175 14.5669C12.7491 14.5669 12.9646 14.3556 13.035 14.2851L14.5849 12.7352C14.8253 12.4948 15.0864 12.3663 15.3433 12.3663C15.6583 12.3663 15.9152 12.5611 16.0769 12.7352L18.5758 15.23C19.0731 15.7273 19.069 16.2661 18.5634 16.7924C18.3893 16.9789 18.207 17.1571 18.0122 17.3436C17.7221 17.6254 17.4196 17.9155 17.1461 18.2429C16.6695 18.7567 16.1017 18.9971 15.3682 18.9971C15.2977 18.9971 15.2231 18.993 15.1527 18.9888C13.7934 18.9018 12.5294 18.3713 11.5804 17.9196C9.00268 16.6722 6.73993 14.9026 4.8626 12.6564C3.31681 10.7957 2.27661 9.06341 1.58867 7.2068C1.16182 6.06714 1.00019 5.15126 1.0665 4.31828Z"
        fill="#03C0FC"
      />
    </g>
    <defs>
      <clipPath id="clip0_2297_68333">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
}

@if (icon == 'location') {
  <svg
    width="18"
    height="23"
    viewBox="0 0 18 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1C4.58871 1 1 4.58871 1 9C1 10.4522 1.65129 12.0141 1.67859 12.08C1.88894 12.5793 2.304 13.3548 2.60329 13.8094L8.08847 22.1205C8.31294 22.4612 8.64518 22.6565 9 22.6565C9.35482 22.6565 9.68706 22.4612 9.91153 22.1209L15.3972 13.8094C15.6969 13.3548 16.1115 12.5793 16.3219 12.08C16.3492 12.0146 17 10.4527 17 9C17 4.58871 13.4113 1 9 1ZM15.4541 11.7148C15.2664 12.1623 14.88 12.8838 14.6113 13.2913L9.12565 21.6028C9.01741 21.7671 8.98306 21.7671 8.87482 21.6028L3.38918 13.2913C3.12047 12.8838 2.73412 12.1619 2.54635 11.7143C2.53835 11.6951 1.94118 10.2574 1.94118 9C1.94118 5.10776 5.10776 1.94118 9 1.94118C12.8922 1.94118 16.0588 5.10776 16.0588 9C16.0588 10.2593 15.4602 11.7007 15.4541 11.7148Z"
      fill="#03C0FC"
      stroke="#03C0FC"
      stroke-width="0.2"
    />
    <path
      d="M8.99994 4.76367C6.66441 4.76367 4.76465 6.66391 4.76465 8.99896C4.76465 11.334 6.66441 13.2343 8.99994 13.2343C11.3355 13.2343 13.2352 11.334 13.2352 8.99896C13.2352 6.66391 11.3355 4.76367 8.99994 4.76367ZM8.99994 12.2931C7.18394 12.2931 5.70582 10.8154 5.70582 8.99896C5.70582 7.18249 7.18394 5.70485 8.99994 5.70485C10.8159 5.70485 12.2941 7.18249 12.2941 8.99896C12.2941 10.8154 10.8159 12.2931 8.99994 12.2931Z"
      fill="#03C0FC"
      stroke="#03C0FC"
      stroke-width="0.2"
    />
  </svg>
}

@if (icon == 'calculation') {
  <svg
    width="26"
    height="438"
    viewBox="0 0 26 438"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.7071 8.20711C26.0976 7.81658 26.0976 7.18342 25.7071 6.79289L19.3431 0.428933C18.9526 0.0384084 18.3195 0.0384085 17.9289 0.428933C17.5384 0.819457 17.5384 1.45262 17.9289 1.84315L23.5858 7.5L17.9289 13.1569C17.5384 13.5474 17.5384 14.1805 17.9289 14.5711C18.3195 14.9616 18.9526 14.9616 19.3431 14.5711L25.7071 8.20711ZM8.58307e-08 8.5L2.08333 8.5L2.08333 6.5L-8.58307e-08 6.5L8.58307e-08 8.5ZM4.16667 8.5L8.33333 8.5L8.33333 6.5L4.16667 6.5L4.16667 8.5ZM10.4167 8.5L14.5833 8.5L14.5833 6.5L10.4167 6.5L10.4167 8.5ZM16.6667 8.5L20.8333 8.5L20.8333 6.5L16.6667 6.5L16.6667 8.5ZM22.9167 8.5L25 8.5L25 6.5L22.9167 6.5L22.9167 8.5ZM1.52588e-07 61L2.08333 61L2.08333 59L-1.52588e-07 59L1.52588e-07 61ZM4.16667 61L8.33333 61L8.33333 59L4.16667 59L4.16667 61ZM10.4167 61L14.5833 61L14.5833 59L10.4167 59L10.4167 61ZM16.6667 61L20.8333 61L20.8333 59L16.6667 59L16.6667 61ZM22.9167 61L25 61L25 59L22.9167 59L22.9167 61ZM1.99998 438L1.99998 436L-1.88072e-05 436L-1.88947e-05 438L1.99998 438ZM1.99998 434L1.99998 430L-1.85448e-05 430L-1.87197e-05 434L1.99998 434ZM1.99998 428L1.99998 424L-1.82823e-05 424L-1.84573e-05 428L1.99998 428ZM1.99998 422L1.99998 418L-1.80199e-05 418L-1.81949e-05 422L1.99998 422ZM1.99998 416L1.99998 412L-1.77575e-05 412L-1.79324e-05 416L1.99998 416ZM1.99998 410L1.99998 406L-1.74951e-05 406L-1.767e-05 410L1.99998 410ZM1.99998 404L1.99998 400L-1.72326e-05 400L-1.74076e-05 404L1.99998 404ZM1.99998 398L1.99998 394L-1.69702e-05 394L-1.71452e-05 398L1.99998 398ZM1.99998 392L1.99998 388L-1.67078e-05 388L-1.68827e-05 392L1.99998 392ZM1.99998 386L1.99998 382L-1.64454e-05 382L-1.66203e-05 386L1.99998 386ZM1.99998 380L1.99998 376L-1.61829e-05 376L-1.63579e-05 380L1.99998 380ZM1.99998 374L1.99998 370L-1.59205e-05 370L-1.60955e-05 374L1.99998 374ZM1.99998 368L1.99998 364L-1.56581e-05 364L-1.5833e-05 368L1.99998 368ZM1.99998 362L1.99998 358L-1.53957e-05 358L-1.55706e-05 362L1.99998 362ZM1.99998 356L1.99998 352L-1.51332e-05 352L-1.53082e-05 356L1.99998 356ZM1.99998 350L1.99999 346L-1.48708e-05 346L-1.50458e-05 350L1.99998 350ZM1.99999 344L1.99999 340L-1.46084e-05 340L-1.47833e-05 344L1.99999 344ZM1.99999 338L1.99999 334L-1.4346e-05 334L-1.45209e-05 338L1.99999 338ZM1.99999 332L1.99999 328L-1.40835e-05 328L-1.42585e-05 332L1.99999 332ZM1.99999 326L1.99999 322L-1.38211e-05 322L-1.39961e-05 326L1.99999 326ZM1.99999 320L1.99999 316L-1.35587e-05 316L-1.37336e-05 320L1.99999 320ZM1.99999 314L1.99999 310L-1.32963e-05 310L-1.34712e-05 314L1.99999 314ZM1.99999 308L1.99999 304L-1.30338e-05 304L-1.32088e-05 308L1.99999 308ZM1.99999 302L1.99999 298L-1.27714e-05 298L-1.29463e-05 302L1.99999 302ZM1.99999 296L1.99999 292L-1.2509e-05 292L-1.26839e-05 296L1.99999 296ZM1.99999 290L1.99999 286L-1.22465e-05 286L-1.24215e-05 290L1.99999 290ZM1.99999 284L1.99999 280L-1.19841e-05 280L-1.21591e-05 284L1.99999 284ZM1.99999 278L1.99999 274L-1.17217e-05 274L-1.18966e-05 278L1.99999 278ZM1.99999 272L1.99999 268L-1.14593e-05 268L-1.16342e-05 272L1.99999 272ZM1.99999 266L1.99999 262L-1.11968e-05 262L-1.13718e-05 266L1.99999 266ZM1.99999 260L1.99999 256L-1.09344e-05 256L-1.11094e-05 260L1.99999 260ZM1.99999 254L1.99999 250L-1.0672e-05 250L-1.08469e-05 254L1.99999 254ZM1.99999 248L1.99999 244L-1.04096e-05 244L-1.05845e-05 248L1.99999 248ZM1.99999 242L1.99999 238L-1.01471e-05 238L-1.03221e-05 242L1.99999 242ZM1.99999 236L1.99999 232L-9.88471e-06 232L-1.00597e-05 236L1.99999 236ZM1.99999 230L1.99999 226L-9.62229e-06 226L-9.79724e-06 230L1.99999 230ZM1.99999 224L1.99999 220L-9.35986e-06 220L-9.53481e-06 224L1.99999 224ZM1.99999 218L1.99999 214L-9.09744e-06 214L-9.27239e-06 218L1.99999 218ZM1.99999 212L1.99999 208L-8.83501e-06 208L-9.00996e-06 212L1.99999 212ZM1.99999 206L1.99999 202L-8.57258e-06 202L-8.74753e-06 206L1.99999 206ZM1.99999 200L1.99999 196L-8.31016e-06 196L-8.48511e-06 200L1.99999 200ZM1.99999 194L1.99999 190L-8.04773e-06 190L-8.22268e-06 194L1.99999 194ZM1.99999 188L1.99999 184L-7.7853e-06 184L-7.96026e-06 188L1.99999 188ZM1.99999 182L1.99999 178L-7.52288e-06 178L-7.69783e-06 182L1.99999 182ZM1.99999 176L1.99999 172L-7.26045e-06 172L-7.4354e-06 176L1.99999 176ZM1.99999 170L1.99999 166L-6.99803e-06 166L-7.17298e-06 170L1.99999 170ZM1.99999 164L1.99999 160L-6.7356e-06 160L-6.91055e-06 164L1.99999 164ZM1.99999 158L1.99999 154L-6.47317e-06 154L-6.64813e-06 158L1.99999 158ZM1.99999 152L1.99999 148L-6.21075e-06 148L-6.3857e-06 152L1.99999 152ZM1.99999 146L1.99999 142L-5.94832e-06 142L-6.12327e-06 146L1.99999 146ZM1.99999 140L1.99999 136L-5.6859e-06 136L-5.86085e-06 140L1.99999 140ZM1.99999 134L1.99999 130L-5.42347e-06 130L-5.59842e-06 134L1.99999 134ZM1.99999 128L1.99999 124L-5.16104e-06 124L-5.336e-06 128L1.99999 128ZM1.99999 122L2 118L-4.89862e-06 118L-5.07357e-06 122L1.99999 122ZM2 116L2 112L-4.63619e-06 112L-4.81114e-06 116L2 116ZM2 110L2 106L-4.37377e-06 106L-4.54872e-06 110L2 110ZM2 104L2 100L-4.11134e-06 100L-4.28629e-06 104L2 104ZM2 98L2 94L-3.84891e-06 94L-4.02387e-06 98L2 98ZM2 92L2 88L-3.58649e-06 88L-3.76144e-06 92L2 92ZM2 86L2 82L-3.32406e-06 82L-3.49901e-06 86L2 86ZM2 80L2 76L-3.06164e-06 76L-3.23659e-06 80L2 80ZM2 74L2 70L-2.79921e-06 70L-2.97416e-06 74L2 74ZM2 68L2 64L-2.53679e-06 64L-2.71174e-06 68L2 68ZM2 62L2 58L-2.27436e-06 58L-2.44931e-06 62L2 62ZM2 56L2 52L-2.01193e-06 52L-2.18688e-06 56L2 56ZM2 50L2 46L-1.74951e-06 46L-1.92446e-06 50L2 50ZM2 44L2 40L-1.48708e-06 40L-1.66203e-06 44L2 44ZM2 38L2 34L-1.22465e-06 34L-1.39961e-06 38L2 38ZM2 32L2 28L-9.62228e-07 28L-1.13718e-06 32L2 32ZM2 26L2 22L-6.99802e-07 22L-8.74753e-07 26L2 26ZM2 20L2 16L-4.37376e-07 16L-6.12327e-07 20L2 20ZM2 14L2 10L-1.74951e-07 10L-3.49901e-07 14L2 14ZM2 7.99999L2 6L0 6L-8.7475e-08 7.99999L2 7.99999ZM0 115H2.08333V113H0V115ZM4.16667 115H8.33333V113H4.16667V115ZM10.4167 115H14.5833V113H10.4167V115ZM16.6667 115H20.8333V113H16.6667V115ZM22.9167 115H25V113H22.9167V115ZM0 223H2.08333V221H0V223ZM4.16667 223H8.33333V221H4.16667V223ZM10.4167 223H14.5833V221H10.4167V223ZM16.6667 223H20.8333V221H16.6667V223ZM22.9167 223H25V221H22.9167V223ZM0 277H2.08333V275H0V277ZM4.16667 277H8.33333V275H4.16667V277ZM10.4167 277H14.5833V275H10.4167V277ZM16.6667 277H20.8333V275H16.6667V277ZM22.9167 277H25V275H22.9167V277ZM0 385H2.08333V383H0V385ZM4.16667 385H8.33333V383H4.16667V385ZM10.4167 385H14.5833V383H10.4167V385ZM16.6667 385H20.8333V383H16.6667V385ZM22.9167 385H25V383H22.9167V385ZM0 331H2.08333V329H0V331ZM4.16667 331H8.33333V329H4.16667V331ZM10.4167 331H14.5833V329H10.4167V331ZM16.6667 331H20.8333V329H16.6667V331ZM22.9167 331H25V329H22.9167V331ZM0 169H2.08333V167H0V169ZM4.16667 169H8.33333V167H4.16667V169ZM10.4167 169H14.5833V167H10.4167V169ZM16.6667 169H20.8333V167H16.6667V169ZM22.9167 169H25V167H22.9167V169Z"
      fill="#B6C9D5"
    />
  </svg>
}

@if (icon == 'role') {
  <svg
    class="text-2"
    role="button"
    width="22"
    height="26"
    viewBox="0 0 19 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9936 4.58333C18.9946 4.47339 18.9521 4.3675 18.8753 4.28875L14.7086 0.122083C14.6303 0.0447917 14.5241 0.0021875 14.4141 0.00375V0H1.91406C1.2237 0 0.664062 0.559635 0.664062 1.25V23.75C0.664062 24.4404 1.2237 25 1.91406 25H17.7474C18.4378 25 18.9974 24.4404 18.9974 23.75V4.58333H18.9936ZM14.8307 1.4225L17.5749 4.16667H15.2474C15.0173 4.16667 14.8307 3.9801 14.8307 3.75V1.4225ZM18.1641 23.75C18.1641 23.9801 17.9775 24.1667 17.7474 24.1667H1.91406C1.68396 24.1667 1.4974 23.9801 1.4974 23.75V1.25C1.4974 1.0199 1.68396 0.833333 1.91406 0.833333H13.9974V3.75C13.9974 4.44036 14.557 5 15.2474 5H18.1641V23.75Z"
    />
    <path
      d="M4.83203 11.25C4.14167 11.25 3.58203 11.8096 3.58203 12.5C3.58203 13.1904 4.14167 13.75 4.83203 13.75C5.5224 13.75 6.08203 13.1904 6.08203 12.5C6.08203 11.8096 5.5224 11.25 4.83203 11.25ZM4.83203 12.9167C4.60193 12.9167 4.41536 12.7301 4.41536 12.5C4.41536 12.2699 4.60193 12.0833 4.83203 12.0833C5.06213 12.0833 5.2487 12.2699 5.2487 12.5C5.2487 12.7301 5.06213 12.9167 4.83203 12.9167Z"
      fill="#B6C9D5"
    />
    <path d="M16.0833 12.083H7.75V12.9163H16.0833V12.083Z" />
    <path
      d="M4.83203 7.08301C4.14167 7.08301 3.58203 7.64264 3.58203 8.33301C3.58203 9.02337 4.14167 9.58301 4.83203 9.58301C5.5224 9.58301 6.08203 9.02337 6.08203 8.33301C6.08203 7.64264 5.5224 7.08301 4.83203 7.08301ZM4.83203 8.74967C4.60193 8.74967 4.41536 8.56311 4.41536 8.33301C4.41536 8.1029 4.60193 7.91634 4.83203 7.91634C5.06213 7.91634 5.2487 8.1029 5.2487 8.33301C5.2487 8.56311 5.06213 8.74967 4.83203 8.74967Z"
    />
    <path d="M16.0833 7.91699H7.75V8.75033H16.0833V7.91699Z" />
    <path
      d="M4.83203 15.417C4.14167 15.417 3.58203 15.9766 3.58203 16.667C3.58203 17.3574 4.14167 17.917 4.83203 17.917C5.5224 17.917 6.08203 17.3574 6.08203 16.667C6.08203 15.9766 5.5224 15.417 4.83203 15.417ZM4.83203 17.0837C4.60193 17.0837 4.41536 16.8971 4.41536 16.667C4.41536 16.4369 4.60193 16.2503 4.83203 16.2503C5.06213 16.2503 5.2487 16.4369 5.2487 16.667C5.2487 16.8971 5.06213 17.0837 4.83203 17.0837Z"
    />
    <path d="M16.0833 16.25H7.75V17.0833H16.0833V16.25Z" />
    <path
      d="M4.83203 19.583C4.14167 19.583 3.58203 20.1426 3.58203 20.833C3.58203 21.5234 4.14167 22.083 4.83203 22.083C5.5224 22.083 6.08203 21.5234 6.08203 20.833C6.08203 20.1426 5.5224 19.583 4.83203 19.583ZM4.83203 21.2497C4.60193 21.2497 4.41536 21.0631 4.41536 20.833C4.41536 20.6029 4.60193 20.4163 4.83203 20.4163C5.06213 20.4163 5.2487 20.6029 5.2487 20.833C5.2487 21.0631 5.06213 21.2497 4.83203 21.2497Z"
    />
    <path d="M16.0833 20.417H7.75V21.2503H16.0833V20.417Z" />
  </svg>
}

@if (icon == 'filter') {
  <svg
    class="text-2"
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.77778 13.3333H12.2222V11.1111H7.77778V13.3333ZM0 0V2.22222H20V0H0ZM3.33333 7.77778H16.6667V5.55556H3.33333V7.77778Z"
    />
  </svg>
}

@if (icon == 'edit') {
  <svg
    class="text-2"
    role="button"
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6666 8.03064C12.298 8.03064 12 8.32935 12 8.69727V14.0306C12 14.398 11.7013 14.6973 11.3334 14.6973H2C1.63196 14.6973 1.33337 14.398 1.33337 14.0306V4.69727C1.33337 4.32996 1.63196 4.03064 2 4.03064H7.33337C7.70203 4.03064 8 3.73193 8 3.36401C8 2.99597 7.70203 2.69727 7.33337 2.69727H2C0.897339 2.69727 0 3.5946 0 4.69727V14.0306C0 15.1333 0.897339 16.0306 2 16.0306H11.3334C12.436 16.0306 13.3334 15.1333 13.3334 14.0306V8.69727C13.3334 8.32861 13.0353 8.03064 12.6666 8.03064Z"
    />
    <path
      d="M6.2488 7.42407C6.20217 7.4707 6.1708 7.53003 6.15749 7.59399L5.68618 9.95142C5.6642 10.0607 5.69887 10.1733 5.77748 10.2527C5.84084 10.316 5.92617 10.35 6.01357 10.35C6.03481 10.35 6.0569 10.348 6.07888 10.3434L8.43557 9.87207C8.50087 9.85864 8.5602 9.82739 8.60622 9.78064L13.8809 4.50598L11.5242 2.14941L6.2488 7.42407Z"
    />
    <path
      d="M15.5137 0.518768C14.8638 -0.131256 13.8064 -0.131256 13.157 0.518768L12.2344 1.44138L14.5911 3.79807L15.5137 2.87534C15.8284 2.56137 16.0017 2.14267 16.0017 1.69736C16.0017 1.25204 15.8284 0.833344 15.5137 0.518768Z"
    />
  </svg>
}

@if (icon == 'delete') {
  <svg
    class="text-2"
    role="button"
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.25 2H10.5V1.5C10.5 0.672906 9.82709 0 9 0H7C6.17291 0 5.5 0.672906 5.5 1.5V2H2.75C2.06075 2 1.5 2.56075 1.5 3.25V5C1.5 5.27612 1.72387 5.5 2 5.5H2.27325L2.70522 14.5713C2.74338 15.3725 3.4015 16 4.2035 16H11.7965C12.5985 16 13.2567 15.3725 13.2948 14.5713L13.7268 5.5H14C14.2761 5.5 14.5 5.27612 14.5 5V3.25C14.5 2.56075 13.9392 2 13.25 2ZM6.5 1.5C6.5 1.22431 6.72431 1 7 1H9C9.27569 1 9.5 1.22431 9.5 1.5V2H6.5V1.5ZM2.5 3.25C2.5 3.11216 2.61216 3 2.75 3H13.25C13.3878 3 13.5 3.11216 13.5 3.25V4.5C13.3459 4.5 3.13853 4.5 2.5 4.5V3.25ZM12.2959 14.5238C12.2832 14.7908 12.0638 15 11.7965 15H4.2035C3.93616 15 3.71678 14.7908 3.70409 14.5238L3.27437 5.5H12.7256L12.2959 14.5238Z"
    />
    <path
      d="M8 14C8.27613 14 8.5 13.7761 8.5 13.5V7C8.5 6.72387 8.27613 6.5 8 6.5C7.72387 6.5 7.5 6.72387 7.5 7V13.5C7.5 13.7761 7.72384 14 8 14Z"
    />
    <path
      d="M10.5 14C10.7761 14 11 13.7761 11 13.5V7C11 6.72387 10.7761 6.5 10.5 6.5C10.2239 6.5 10 6.72387 10 7V13.5C10 13.7761 10.2238 14 10.5 14Z"
    />
    <path
      d="M5.5 14C5.77613 14 6 13.7761 6 13.5V7C6 6.72387 5.77613 6.5 5.5 6.5C5.22387 6.5 5 6.72387 5 7V13.5C5 13.7761 5.22384 14 5.5 14Z"
    />
  </svg>
}

@if (icon == 'maker') {
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3389 13.2143C15.4671 9.87469 15.1996 10.2913 15.2609 10.2043C16.0358 9.11137 16.4453 7.82508 16.4453 6.48438C16.4453 2.92891 13.5601 0 10 0C6.45148 0 3.55469 2.92313 3.55469 6.48438C3.55469 7.82422 3.97281 9.14418 4.77305 10.2518L6.66102 13.2143C4.64246 13.5245 1.21094 14.4489 1.21094 16.4844C1.21094 17.2264 1.69523 18.2838 4.00242 19.1078C5.61344 19.6831 7.7434 20 10 20C14.2197 20 18.7891 18.8097 18.7891 16.4844C18.7891 14.4486 15.3616 13.5251 13.3389 13.2143ZM5.75191 9.60723C5.74547 9.59715 5.73875 9.5873 5.73172 9.57762C5.06582 8.66152 4.72656 7.57582 4.72656 6.48438C4.72656 3.55398 7.08617 1.17188 10 1.17188C12.9078 1.17188 15.2734 3.55504 15.2734 6.48438C15.2734 7.57758 14.9406 8.62645 14.3107 9.5184C14.2543 9.59285 14.5487 9.13535 10 16.273L5.75191 9.60723ZM10 18.8281C5.39086 18.8281 2.38281 17.4733 2.38281 16.4844C2.38281 15.8197 3.92844 14.7268 7.35344 14.3007L9.50586 17.6782C9.61344 17.847 9.79977 17.9492 9.99996 17.9492C10.2002 17.9492 10.3865 17.847 10.4941 17.6782L12.6464 14.3007C16.0715 14.7268 17.6172 15.8197 17.6172 16.4844C17.6172 17.4649 14.6362 18.8281 10 18.8281Z"
      fill="#03C0FC"
    />
    <path
      d="M10 3.55469C8.38457 3.55469 7.07031 4.86895 7.07031 6.48438C7.07031 8.0998 8.38457 9.41406 10 9.41406C11.6154 9.41406 12.9297 8.0998 12.9297 6.48438C12.9297 4.86895 11.6154 3.55469 10 3.55469ZM10 8.24219C9.03074 8.24219 8.24219 7.45363 8.24219 6.48438C8.24219 5.51512 9.03074 4.72656 10 4.72656C10.9693 4.72656 11.7578 5.51512 11.7578 6.48438C11.7578 7.45363 10.9693 8.24219 10 8.24219Z"
      fill="#03C0FC"
    />
  </svg>
}

@if (icon == 'DESC') {
  <svg
    class="text-1 ms-2"
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.77778 13.3333H12.2222V11.1111H7.77778V13.3333ZM0 0V2.22222H20V0H0ZM3.33333 7.77778H16.6667V5.55556H3.33333V7.77778Z"
    />
  </svg>
}
@if (icon == 'ASC') {
  <svg
    class="text-1 ms-2"
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6111 0.669941H7.38889V2.78105H11.6111V0.669941ZM19 13.3366V11.2255H5.62519e-07V13.3366H19ZM15.8333 5.94772H3.16667V8.05883H15.8333V5.94772Z"
    />
  </svg>
}

@if (icon == 'round_close') {
  <svg
    class="me-2"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2216 2.77839C12.5171 -0.926129 6.48749 -0.926129 2.78297 2.77839C0.988492 4.57357 0 6.95984 0 9.4977C0 12.0356 0.988492 14.4218 2.78297 16.2163C4.6356 18.0689 7.06896 18.9949 9.50228 18.9949C11.9356 18.9949 14.369 18.0689 16.2216 16.2163C19.9261 12.5118 19.9261 6.48361 16.2216 2.77839ZM15.1809 15.1755C12.0497 18.3067 6.95485 18.3067 3.82371 15.1755C2.30748 13.6593 1.47207 11.6425 1.47207 9.4977C1.47207 7.35287 2.30748 5.3361 3.82371 3.81913C6.95485 0.687996 12.0497 0.688738 15.1809 3.81913C18.3112 6.95026 18.3112 12.0451 15.1809 15.1755Z"
    />
    <path
      d="M12.6729 11.5357L10.5891 9.45495L12.6729 7.37417C12.9599 7.08713 12.9599 6.62122 12.6736 6.3334C12.3858 6.04487 11.9199 6.04561 11.6321 6.33266L9.54695 8.41491L7.46175 6.33266C7.17397 6.04561 6.70805 6.04487 6.42027 6.3334C6.13322 6.62118 6.13322 7.08709 6.42101 7.37417L8.50476 9.45495L6.42101 11.5357C6.13322 11.8228 6.13322 12.2887 6.42027 12.5765C6.56381 12.7207 6.75296 12.7921 6.9414 12.7921C7.12984 12.7921 7.31825 12.72 7.46179 12.5772L9.54699 10.4949L11.6322 12.5772C11.7757 12.7207 11.9641 12.7921 12.1526 12.7921C12.341 12.7921 12.5302 12.72 12.6737 12.5765C12.9607 12.2887 12.9607 11.8228 12.6729 11.5357Z"
    />
  </svg>
}

@if (icon == 'round_correct') {
  <svg
    class="me-2"
    width="20"
    height="19"
    viewBox="0 0 20 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2925_58710)">
      <path
        d="M14.1994 6.48559C14.4894 6.77551 14.4894 7.24546 14.1994 7.53523L9.22041 12.5144C8.9305 12.8042 8.46069 12.8042 8.17077 12.5144L5.80055 10.1441C5.51064 9.85428 5.51064 9.38432 5.80055 9.09455C6.09032 8.80463 6.56028 8.80463 6.85005 9.09455L8.69552 10.94L13.1498 6.48559C13.4397 6.19582 13.9097 6.19582 14.1994 6.48559ZM19.5 9.5C19.5 14.7511 15.2504 19 10 19C4.74888 19 0.5 14.7504 0.5 9.5C0.5 4.24888 4.7496 0 10 0C15.2511 0 19.5 4.2496 19.5 9.5ZM18.0156 9.5C18.0156 5.06934 14.4301 1.48438 10 1.48438C5.56934 1.48438 1.98438 5.06992 1.98438 9.5C1.98438 13.9307 5.56992 17.5156 10 17.5156C14.4307 17.5156 18.0156 13.9301 18.0156 9.5Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_2925_58710">
        <rect width="19" height="19" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
}

@if (icon == 'view') {
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48608 0 0 4.48608 0 10C0 15.514 4.48608 20 10 20C15.514 20 20 15.514 20 10C20 4.48608 15.5139 0 10 0ZM10.6505 15.9333C10.1754 16.0125 9.23006 16.2103 8.75001 16.25C8.34366 16.2837 7.96021 16.0511 7.72646 15.7172C7.4921 15.3833 7.43594 14.9561 7.57508 14.5728L9.46533 9.37503H7.49999C7.49832 8.29197 8.3107 7.49561 9.34974 7.18998C9.84558 7.04409 10.7694 6.84445 11.25 6.87505C11.5379 6.89336 12.0398 7.074 12.2735 7.4079C12.5079 7.74176 12.5641 8.16901 12.4249 8.55231L10.5347 13.7501H12.4994C12.4998 14.8319 11.7177 15.7554 10.6505 15.9333ZM11.25 6.25002C10.5596 6.25002 9.99998 5.69031 9.99998 5.00001C9.99998 4.30963 10.5596 3.75 11.25 3.75C11.9404 3.75 12.5 4.30963 12.5 5.00001C12.5 5.69035 11.9404 6.25002 11.25 6.25002Z"
      fill="#03C0FC"
    />
  </svg>
}

@if (icon == 'map') {
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.66979 6.00779H8.57771V6.57972C8.57771 8.18314 7.27329 9.48764 5.66979 9.48764C4.06629 9.48764 2.76187 8.18314 2.76187 6.57972C2.76187 4.97629 4.06636 3.67179 5.66979 3.67179C6.31741 3.67179 6.93037 3.88016 7.44242 4.2744L6.74458 5.18077C6.43436 4.94195 6.0627 4.81565 5.66979 4.81565C4.69708 4.81565 3.90573 5.60701 3.90573 6.57972C3.90573 7.55242 4.69708 8.34378 5.66979 8.34378C6.44238 8.34378 7.10066 7.8445 7.3387 7.15157H5.66979V6.00779ZM19.6869 4.40452C19.6869 5.48055 19.3294 6.3212 18.8447 7.06428V19.0267C18.8447 19.5634 18.4081 20 17.8714 20H1.28583C0.749097 20 0.3125 19.5634 0.3125 19.0267V2.44111C0.3125 1.90438 0.749097 1.46778 1.28583 1.46778H12.0033C12.8103 0.567646 13.981 0 15.2822 0C17.711 0 19.6869 1.97586 19.6869 4.40452ZM1.4805 18.023L12.0157 7.48795C11.3879 6.63936 10.8778 5.68994 10.8778 4.40459C10.8778 3.77567 11.0113 3.17757 11.2498 2.63578H1.4805V18.023ZM16.8679 18.832L9.57861 11.5427L2.2893 18.832H16.8679ZM17.6766 8.58049C16.8409 9.60794 16.1002 10.6314 16.1002 12.264V12.848H14.4643V12.264C14.4643 10.5303 13.6291 9.48351 12.7317 8.38949L10.3874 10.7338L17.6766 18.0231V8.58049ZM18.5189 4.40452C18.5189 2.61989 17.067 1.168 15.2823 1.168C13.4977 1.168 12.0459 2.61989 12.0459 4.40452C12.0459 5.71213 12.761 6.58361 13.589 7.59276C14.2099 8.34946 14.8846 9.17173 15.2823 10.2506C15.6801 9.17173 16.3548 8.34946 16.9757 7.59276C17.8037 6.58369 18.5189 5.71213 18.5189 4.40452ZM15.2822 2.65719C14.4601 2.65719 13.7935 3.32373 13.7935 4.14592C13.7935 4.96819 14.4601 5.63473 15.2822 5.63473C16.1046 5.63473 16.7711 4.96811 16.7711 4.14592C16.7711 3.32373 16.1046 2.65719 15.2822 2.65719Z"
      fill="#03C0FC"
    />
  </svg>
}
